import { createActions, createReducer } from "reduxsauce"
import { get, omit, chain } from "lodash"

export const { Types, Creators } = createActions({
  toggleFacet: ["facetType", "id"],
  toggleClassificationFacets: ["facetType", "tier", "ids", "selected"],
  expandFacet: ["facetType"],
  close: [],
}, {
  prefix: "ompnt/modules/watchlist-facets/",
})

const DEFAULT_STATE = {
  country: {},
  currency: {},
  classifications: {},
  expanded: null,
}

function handleToggleFacet(state, { facetType, id }) {
  const toggled = get(state, [facetType, id], false)
  if (!toggled) {
    return { ...state, [facetType]: { ...state[facetType], [id]: true } }
  } else {
    return { ...state, [facetType]: omit(state[facetType], id) }
  }
}

function handleToggleClassificationFacets(state, { facetType, tier, ids, selected }) {
  // eg: { GICS: {}, GICSPlus: {}, custom1: {}}
  const currentClassifications = state.classifications
  const currentClassification = get(state, ["classifications", facetType], {})

  return {
    ...state,
    classifications: {
      ...currentClassifications,
      [facetType]: {
        ...currentClassification,
        ...chain(ids).mapKeys(id => id).mapValues(() => ({ tier, selected })).value(),
      },
    },
  }
}

function handleExpandFacet(state, { facetType }) {
  return { ...state, expanded: facetType }
}

function handleClose(state) {
  return { ...state, expanded: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE_FACET]: handleToggleFacet,
  [Types.TOGGLE_CLASSIFICATION_FACETS]: handleToggleClassificationFacets,
  [Types.EXPAND_FACET]: handleExpandFacet,
  [Types.CLOSE]: handleClose,
})
